import script from "./analysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./analysis.vue?vue&type=script&setup=true&lang=ts"

import "./analysis.vue?vue&type=style&index=0&id=6a8575d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8575d9"]])

export default __exports__